import { isEmpty } from 'lodash';
import React from 'react';

import Redirect from '@swf/components/Redirect/Redirect';
import Translation from '@swf/components/Translation/Translation';
import { RoutingKey } from '@swf/core/enums';
import {
  Loader,
  NoData,
  PokerGameTileContainer,
  useGetWidgetState,
  useIsWidgetLoading,
  useMapGameData,
  usePollClubInfo
} from '@swf/poker';

import {
  TXTWCL_Cash_Games_from_your_clubs_wil_ELL,
  TXTWCL_No_Cash_Games_to_Show
} from './CashGames.messages.json';
import styles from './CashGames.scss';
import NoDataIcon from './assets/no-data.svg';

const CashGames: React.FC = () => {
  const {
    clubs,
    games: { tables }
  } = useGetWidgetState();
  const loading = useIsWidgetLoading();
  const noClubs = isEmpty(clubs);
  const noGames = isEmpty(tables);
  const { mappedTables } = useMapGameData({ shouldMapTables: true });

  usePollClubInfo();

  if (!loading && noClubs) {
    return <Redirect routingKey={RoutingKey.HomeGamesClubs} />;
  }

  return (
    <div className={styles.container}>
      <Loader loading={loading}>
        {noGames ? (
          <NoData
            icon={<NoDataIcon />}
            primaryText={<Translation {...TXTWCL_No_Cash_Games_to_Show} />}
            secondaryText={<Translation {...TXTWCL_Cash_Games_from_your_clubs_wil_ELL} />}
          />
        ) : (
          <PokerGameTileContainer games={mappedTables} clubs={clubs} />
        )}
      </Loader>
    </div>
  );
};

export default CashGames;
